import React, { Component } from 'react';
import Buttons from '../../../core/Buttons';
import Icon from '../../../core/Icon';
import { Pencil } from '../../../../../assets/images/index';
import {
  postDocument,
  uploadDocument,
  createStructure,
  findDocument,
  findNewFolder
} from '../../../../utils/apiDepartment';
import ModalMultipleGroups from '../../../views/Common/ModalMultipleGroups';
import {
  StyledLabel,
  StyledGroupInput,
  StyledWrapperGroupInput,
  StyledButtonPencil,
  StyledWrapperButtons
} from './style';
import FileDropInput from '../FileDropInput';
import { getUser, getUserDetails } from '../../../../utils/apiUser';

const createSubFolderGroupId = [];
const manageGroupId = [];
const exploreGroupId = [];
let userId = '';

export default class NewFile extends Component {
  constructor(props) {
    super(props);

    const { parentFolderId } = this.props.match.params;
    this.inputFileRef = React.createRef();
    this.onFileChange = this.handleFileChange.bind(this);
    this.state = {
      document: {
        creationDate: '',
        creationUser: '',
        folderId: parentFolderId,
        fileName: '',
        clientPath: '',
        manageGroupId: [],
        exploreGroupId: [],
        baseContentType: 'DOCUMENT',
        status: 'PUBLISHED',
        typology: 'INTERNAL'
      },
      file: null,
      validForm: false,
      showModalGroupManage: false,
      showModalGroupExplore: false,
      showModalGroupCreateSubFolder: false
    };
  }

  componentDidMount() {
    const fileId = new URLSearchParams(this.props.location.search).get(
      'fileId'
    );
    getUser();
    getUserDetails().then(response => {
      console.log(response.userProfile.userId);
      userId = response.userProfile.userId;
    });
    findNewFolder(this.props.match.params.parentFolderId).then(resp => {
      this.setState(prevState => ({
        document: {
          ...prevState.document,
          manageGroupId: resp.manageGroupId,
          createSubFolderGroupId: resp.createSubFolderGroupId
        }
      }));
    });
    if (fileId) {
      findDocument(fileId)
        .then(document => {
          this.setState(prevState => ({
            document: {
              ...prevState.document,
              id: document.id,
              title: document.title,
              fileName: document.fileName,
              parentFolderId: document.parentFolderId,
              exploreGroupId: document.exploreGroupId,
              manageGroupId: document.manageGroupId
            }
          }));
        })
        .catch(() => {});
    }
  }

  sendInput = data => {
    const { history } = this.props;
    const { file } = this.state;
    const objectClean = { ...data, title: data.title };
    objectClean.creationDate = new Date();
    const formData = new FormData();

    const { originPath, breadcrumbData, currentFolder } =
      history.location.state || {};
    const previousPath = originPath;
    if (this.state.document?.id) {
      formData.append('file', file);
      postDocument({
        ...objectClean,
        clientPath: this.state.document?.clientPath
      }).then();
      history.goBack();
    } else if (this.props.location.pathname.includes('isStructure') == true) {
      const tiposMIMEValidos = [
        'application/zip',
        'application/x-zip-compressed'
      ];
      const extensionValida = file.name.endsWith('.zip');
      if (tiposMIMEValidos.includes(file.type) && extensionValida) {
        formData.append('zipFile', file);
        const parenFolder = this.props.match.params.parentFolderId;
        const questionMarkIndex = parenFolder.indexOf('?');
        formData.append(
          'parentFolderId',
          questionMarkIndex > 0
            ? parenFolder.substring(0, questionMarkIndex)
            : parenFolder
        );
        formData.append(
          'createSubFolderGroupId',
          this.state.document.createSubFolderGroupId
        );
        formData.append('exploreGroupId', this.state.document.exploreGroupId);
        formData.append('manageGroupId', this.state.document.manageGroupId);
        createStructure(formData, userId).then(response => {
          history.push({
            pathname: previousPath,
            state: {
              breadcrumbData,
              currentFolder
            }
          });
        });
      } else {
        history.goBack();
      }
    } else {
      formData.append('file', file);
      uploadDocument(formData)
        .then(resp => {
          postDocument({ ...objectClean, clientPath: resp }).then(() => {
            history.push({
              pathname: previousPath,
              state: {
                breadcrumbData,
                currentFolder
              }
            });
          });
        })
        .catch(() => {});
    }
  };

  onSaveGroup = (idGroup, folderPermissionType) => {
    switch (folderPermissionType) {
      case 'manage':
        this.setState(prevState => ({
          document: {
            ...prevState.document,
            manageGroupId: [idGroup]
          },
          showModalGroupManage: false
        }));
        break;
      case 'explore':
        this.setState(prevState => ({
          document: {
            ...prevState.document,
            exploreGroupId: [idGroup]
          },
          showModalGroupExplore: false
        }));
        break;
      case 'createSubFolder':
        this.setState(prevState => ({
          document: {
            ...prevState.document,
            createSubFolderGroupId: [idGroup]
          },
          showModalGroupCreateSubFolder: false
        }));
        break;
      default:
    }
  };

  handleFileChange = e => {
    if (e) {
      const fileName = e.name;
      const file = e;
      const { validForm } = this.state;

      this.setState(prevState => ({
        document: {
          ...prevState.document,
          fileName,
          title: fileName
        },
        file,
        validForm: validForm === false
      }));
    }
  };

  render() {
    const { history } = this.props;
    const {
      document,
      validForm,
      showModalGroupManage,
      showModalGroupExplore,
      showModalGroupCreateSubFolder
    } = this.state;
    const {
      title,
      manageGroupId,
      exploreGroupId,
      createSubFolderGroupId
    } = document;
    if (this.props.location.pathname.includes('isStructure')) {
      return (
        <React.Fragment>
          <FileDropInput
            title={title}
            document={this.state.document}
            onTitleChange={title =>
              this.setState(prev => ({
                document: { ...prev.document, title },
                validForm: title !== ''
              }))
            }
            onFileChange={file => this.onFileChange(file)}
          />

          <StyledLabel>Id grupo con permisos para crear documento</StyledLabel>
          <StyledWrapperGroupInput>
            <StyledGroupInput
              id="createSubFolderGroupId"
              name="createSubFolderGroupId"
              type="text"
              value={createSubFolderGroupId}
            />
            <StyledButtonPencil>
              <Icon
                hover
                size="m"
                color="main"
                svg={Pencil}
                onClick={() => {
                  this.setState({ showModalGroupCreateSubFolder: true });
                }}
              />
            </StyledButtonPencil>
          </StyledWrapperGroupInput>

          <StyledLabel>
            Id grupo con permisos para administrar documento
          </StyledLabel>
          <StyledWrapperGroupInput>
            <StyledGroupInput
              id="manageGroupId"
              name="manageGroupId"
              type="text"
              value={manageGroupId}
            />
            <StyledButtonPencil>
              <Icon
                hover
                size="m"
                color="main"
                svg={Pencil}
                onClick={() => {
                  this.setState({ showModalGroupManage: true });
                }}
              />
            </StyledButtonPencil>
          </StyledWrapperGroupInput>

          <StyledLabel>
            Id grupo con permisos para explorar documento
          </StyledLabel>
          <StyledWrapperGroupInput>
            <StyledGroupInput
              id="exploreGroupId"
              name="exploreGroupId"
              type="text"
              value={exploreGroupId}
            />
            <StyledButtonPencil>
              <Icon
                hover
                size="m"
                color="main"
                svg={Pencil}
                onClick={() => {
                  this.setState({ showModalGroupExplore: true });
                }}
              />
            </StyledButtonPencil>
          </StyledWrapperGroupInput>

          <StyledWrapperButtons>
            <Buttons
              secondary
              className="fr"
              type="submit"
              small
              onClick={() => this.sendInput(document)}
              disabled={!validForm}
            >
              {document.id ? 'Modificar' : 'Crear'} Estructura
            </Buttons>
            <Buttons
              secondary
              className="fr"
              type="submit"
              small
              onClick={() => history.goBack()}
            >
              Volver
            </Buttons>
          </StyledWrapperButtons>
          {showModalGroupManage && (
            <ModalMultipleGroups
              onClose={() => {
                this.setState({ showModalGroupManage: false });
              }}
              onSaveGroup={this.onSaveGroup}
              folderPermissionType="manage"
            />
          )}
          {showModalGroupExplore && (
            <ModalMultipleGroups
              onClose={() => {
                this.setState({ showModalGroupExplore: false });
              }}
              onSaveGroup={this.onSaveGroup}
              folderPermissionType="explore"
            />
          )}
          {showModalGroupCreateSubFolder && (
            <ModalMultipleGroups
              onClose={() => {
                this.setState({ showModalGroupCreateSubFolder: false });
              }}
              onSaveGroup={this.onSaveGroup}
              folderPermissionType="createSubFolder"
            />
          )}
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <FileDropInput
          title={title}
          document={this.state.document}
          onTitleChange={title =>
            this.setState(prev => ({
              document: { ...prev.document, title },
              validForm: title !== ''
            }))
          }
          onFileChange={file => this.onFileChange(file)}
        />

        <StyledLabel>
          Id grupo con permisos para administrar documento
        </StyledLabel>
        <StyledWrapperGroupInput>
          <StyledGroupInput
            id="manageGroupId"
            name="manageGroupId"
            type="text"
            value={manageGroupId}
          />
          <StyledButtonPencil>
            <Icon
              hover
              size="m"
              color="main"
              svg={Pencil}
              onClick={() => {
                this.setState({ showModalGroupManage: true });
              }}
            />
          </StyledButtonPencil>
        </StyledWrapperGroupInput>

        <StyledLabel>Id grupo con permisos para explorar documento</StyledLabel>
        <StyledWrapperGroupInput>
          <StyledGroupInput
            id="exploreGroupId"
            name="exploreGroupId"
            type="text"
            value={exploreGroupId}
          />
          <StyledButtonPencil>
            <Icon
              hover
              size="m"
              color="main"
              svg={Pencil}
              onClick={() => {
                this.setState({ showModalGroupExplore: true });
              }}
            />
          </StyledButtonPencil>
        </StyledWrapperGroupInput>

        <StyledWrapperButtons>
          <Buttons
            secondary
            className="fr"
            type="submit"
            small
            onClick={() => this.sendInput(document)}
            disabled={!validForm}
          >
            {document.id ? 'Modificar' : 'Crear'} Documento
          </Buttons>
          <Buttons
            secondary
            className="fr"
            type="submit"
            small
            onClick={() => history.goBack()}
          >
            Volver
          </Buttons>
        </StyledWrapperButtons>
        {showModalGroupManage && (
          <ModalMultipleGroups
            onClose={() => {
              this.setState({ showModalGroupManage: false });
            }}
            onSaveGroup={this.onSaveGroup}
            folderPermissionType="manage"
          />
        )}
        {showModalGroupExplore && (
          <ModalMultipleGroups
            onClose={() => {
              this.setState({ showModalGroupExplore: false });
            }}
            onSaveGroup={this.onSaveGroup}
            folderPermissionType="explore"
          />
        )}
        {showModalGroupCreateSubFolder && (
          <ModalMultipleGroups
            onClose={() => {
              this.setState({ showModalGroupCreateSubFolder: false });
            }}
            onSaveGroup={this.onSaveGroup}
            folderPermissionType="createSubFolder"
          />
        )}
      </React.Fragment>
    );
  }
}
